import { Controller } from "@hotwired/stimulus"

// Copies the source target's text and says so in a live region, so the
// confirmation reaches screen readers too. When the browser refuses to copy,
// the text is selected instead, so the keyboard shortcut is one step away.
export default class extends Controller {
  static targets = ["source", "status"]
  // Hvad der bliver kopieret, så beskeden kan sige det: "Linket er kopieret",
  // "Telefonnummeret er kopieret". Uden den ville en side, der kopierer andet
  // end links, lyve i en live region.
  static values = { label: { type: String, default: "Linket" } }

  copy() {
    const written = navigator.clipboard?.writeText(this.sourceTarget.textContent.trim())

    if (written) {
      written.then(() => this.announce(`${this.labelValue} er kopieret.`), () => this.fallback())
    } else {
      this.fallback()
    }
  }

  fallback() {
    this.select()
    this.announce(`${this.labelValue} kunne ikke kopieres. Det er markeret nu, så du kan kopiere det selv.`)
  }

  select() {
    const range = document.createRange()
    range.selectNodeContents(this.sourceTarget)
    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
  }

  announce(message) {
    this.statusTarget.textContent = message
  }
}
